import { ApolloClient, InMemoryCache, createHttpLink, NormalizedCacheObject } from '@apollo/client';
import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

import { env } from '@/environment';
import { logWarn } from '@/helpers/logger/logUtils';

if (env.NODE_ENV === 'development') {
  loadDevMessages();
  loadErrorMessages();
}

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => logWarn(`[GQL]: "${path}" ${message} (${locations})`));
  }
  if (networkError) {
    logWarn(`[GQL Network ERROR]: ${networkError}`);
  }
});

const getAuthLink = (accessToken: string) =>
  setContext((_, { headers }) => ({
    headers: {
      ...headers,
      authorization: `bearer ${accessToken}`,
    },
  }));

export const createApolloClient = (apiDomainName: string, accessToken: string): ApolloClient<NormalizedCacheObject> => {
  // local url: 'http://localhost:3002/graphql'
  // DEV   url: 'https://dev.gcpshore.virginvoyages.com/graphql'

  const httpLink = createHttpLink({ uri: `${apiDomainName}/graphql` });

  return new ApolloClient({
    ssrMode: typeof window === 'undefined',
    link: getAuthLink(accessToken)?.concat(errorLink)?.concat(httpLink),
    cache: new InMemoryCache(),
  });
};
